
import { useEffect, useState } from 'react';

interface CartNotificationProps {
  show: boolean;
  productName: string;
  onClose: () => void;
}

const CartNotification = ({ show, productName, onClose }: CartNotificationProps) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div className="fixed top-24 right-6 z-50 animate-slide-in-right">
      <div 
        className="bg-white border border-gray-200 rounded-lg shadow-lg p-4 max-w-sm"
        style={{ backgroundColor: '#F8F8F8' }}
      >
        <div className="flex items-center space-x-3">
          <div 
            className="w-8 h-8 rounded-full flex items-center justify-center"
            style={{ backgroundColor: '#0F3F2F' }}
          >
            <i className="ri-check-line text-white text-sm"></i>
          </div>
          <div className="flex-1">
            <p 
              className="text-sm font-medium"
              style={{ 
                color: '#0B0B0B',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              Produto adicionado ao carrinho
            </p>
            <p 
              className="text-xs"
              style={{ 
                color: '#C0C0C0',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              {productName}
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <i className="ri-close-line text-sm"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartNotification;
